"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.backofficePim_en_us = void 0;
function backofficePim_en_us() {
    return {
        "backoffice.pim.title": "Products",
        "backoffice.pim.pricezones.edit": "Edit price zone",
        "backoffice.pim.pricezones.add": "Add price zone",
        "backoffice.pim.pricezones.title": "Price zones",
        "backoffice.pim.pricezones.subtitle": "Price zones enable you to to define the price for your products in various currencies.",
        "backoffice.pim.pricezones.tabheader": "Price zones",
        "backoffice.pim.pricezones.titleinput": "Title",
        "backoffice.pim.pricezones.table.title": "Title",
        "backoffice.pim.pricezones.table.currency": "Currency (ISO)",
        "backoffice.pim.pricezones.empty.headline": "No pricezones created yet",
        "backoffice.pim.pricezones.empty.message": "Get started and created one",
        "backoffice.pim.pricezones.empty.creationtitle": "Create new price zone",
        "backoffice.pim.pricezones.success.create": "The price zone was created successfully",
        "backoffice.pim.pricezones.success.update": "The price zone was updated successfully",
        "backoffice.pim.pricezones.success.delete": "The price zone was delete successfully",
        "backoffice.pim.pricezones.error.create": "Creating the price zone failed",
        "backoffice.pim.pricezones.error.update": "Updating the price zone failed",
        "backoffice.pim.pricezones.error.delete": "Deleting the price zone failed",
        "backoffice.pim.pricezones.info.title": "ISO 4217 Definition",
        "backoffice.pim.pricezones.info.message": "ISO 4217 is the standard published by the International Organization for Standardization for currency symbols that are to be used for unique identification in international payment transactions. The ISO abbreviations each consist of three letters. The first two are usually the country code (e.g. AU for Australia), the last letter is usually the first letter of the currency name, e.g. D for dollar. Examples: AUD = Australian Dollar, EUR = Euro, USD = US-Dollar",
        "backoffice.pim.supplier.tabheader": "Suppliers",
        "backoffice.pim.supplier.title": "Suppliers",
        "backoffice.pim.supplier.subtitle": "Overview of your suppliers.",
        "backoffice.pim.supplier.table.title": "Title",
        "backoffice.pim.supplier.table.code": "Code",
        "backoffice.pim.supplier.table.orderplacementserviceurl": "Order placement sevice url",
        "backoffice.pim.supplier.empty.headline": "No suppliers created yet",
        "backoffice.pim.supplier.empty.message": "Get started and created one",
        "backoffice.pim.supplier.editor.add": "Add supplier",
        "backoffice.pim.supplier.editor.edit": "Edit supplier",
        "backoffice.pim.supplier.editor.title": "Supplier title",
        "backoffice.pim.supplier.editor.code": "Supplier code",
        "backoffice.pim.supplier.editor.customfields": "Custom fields",
        "backoffice.pim.supplier.editor.field": "Field",
        "backoffice.pim.supplier.editor.value": "Value",
        "backoffice.pim.supplier.editor.orderplacementserviceurl": "Supplier order placement service url",
        "backoffice.pim.supplier.editor.orderplacementserviceauthheader": "Order Placement Auth Header",
        "backoffice.pim.products.tabheader": "Products",
        "backoffice.pim.products.title": "Products Overview",
        "backoffice.pim.products.add": "Add Product",
        "backoffice.pim.products.empty.headline": "No products found",
        "backoffice.pim.products.empty.message": "How about creating some?",
        "backoffice.pim.products.duplicate.title": "Duplicate product",
        "backoffice.pim.products.duplicate.message": "Do you really want to duplicate this product",
        "backoffice.pim.products.images.empty.headline": "No product imagess found",
        "backoffice.pim.products.images.empty.message": "How about adding some?",
        "backoffice.pim.products.draft.active": "active",
        "backoffice.pim.products.draft.inactive": "inactive",
        "backoffice.pim.products.draft.title": "Title",
        "backoffice.pim.products.draft.shorttitle": "Short Title",
        "backoffice.pim.products.draft.description": "Description",
        "backoffice.pim.products.draft.shortdescription": "Short Description",
        "backoffice.pim.products.draft.pricezones.none": "You don't have any price zones yet",
        "backoffice.pim.products.draft.pricezones.create": "Create price zone",
        "backoffice.pim.products.draft.header.title": "Producteditor",
        "backoffice.pim.products.draft.header.edit": "Edit your product details",
        "backoffice.pim.products.draft.header.create": "Add a new product",
        "backoffice.pim.products.draft.tags": "Tags",
        "backoffice.pim.products.draft.tagsdescription": "Tags can be used to sort, filter or group your products",
        "backoffice.pim.products.draft.edit": "Edit product",
        "backoffice.pim.products.draft.edithint": "Below you can edit your product details...",
        "backoffice.pim.products.draft.all": "All Products",
        "backoffice.pim.products.draft.add": "Add a product",
        "backoffice.pim.products.draft.addimage": "Add an image",
        "backoffice.pim.products.draft.addhint": "Over here you can add a new product",
        "backoffice.pim.products.draft.basicinfo": "Basic Information",
        "backoffice.pim.products.draft.prices": "Prices",
        "backoffice.pim.products.draft.pricehint": "Set the price for the product for a specific price zone",
        "backoffice.pim.products.draft.save.success": "Products were updated successfully",
        "backoffice.pim.products.draft.save.error": "Failed updating products",
        "backoffice.pim.products.draft.supplier.title": "Product specific supplier details",
        "backoffice.pim.products.draft.supplier.selectsupplier": "Select supplier",
        "backoffice.pim.products.draft.supplier.selectnone": "Select none",
        "backoffice.pim.products.draft.supplier.articleidentifier": "Supplier specific article identifier (optional)",
        "backoffice.pim.products.draft.supplier.description": "Here you can select a supplier and, if necessary, enter an article number.",
        "backoffice.pim.products.draft.metadata.label": "Project related data",
        "backoffice.pim.products.draft.metadata.description": "Here you can add project related data to your products",
        "backoffice.pim.products.product.basicinfo": "Basic Infos",
        "backoffice.pim.products.product.options": "Options",
        "backoffice.pim.products.product.variants": "Variants",
        "backoffice.pim.products.product.images": "Images",
        "backoffice.pim.products.delete.success": "The product was deleted successfully",
        "backoffice.pim.products.table.image": "Image",
        "backoffice.pim.products.table.title": "Title",
        "backoffice.pim.products.table.active": "Active",
        "backoffice.pim.products.table.createdat": "Created at",
        "backoffice.pim.products.table.tags": "Tags",
        "backoffice.pim.products.table.options": "Options",
        "backoffice.pim.products.table.prices": "Prices",
        "backoffice.pim.products.oms.workflows.events.placed.label": "Order Placed",
        "backoffice.pim.products.oms.workflows.events.placed.description": "Will be fired whenever an order was placed.",
        "backoffice.pim.oms.title": "Orders",
        "backoffice.pim.oms.subtitle": "Overview of orders made by your customers.",
        "backoffice.pim.oms.orders.table.orderdate": "Order Date",
        "backoffice.pim.oms.orders.table.user": "User",
        "backoffice.pim.oms.orders.table.company": "Company",
        "backoffice.pim.oms.orders.table.orderpositions": "Order Positions",
        "backoffice.pim.oms.orders.table.deliveryaddress": "Delivery Address",
        "backoffice.pim.oms.orders.table.supplier": "Supplier",
        "backoffice.pim.oms.orders.table.status": "State",
        "backoffice.pim.oms.orders.table.statushistory": "Status History",
        "backoffice.pim.oms.orders.empty.headline": "No orders found",
        "backoffice.pim.oms.orders.empty.message": "It seems, there are no orders here, yet. Get your customers to buy your products. Then you can see here the orders."
    };
}
exports.backofficePim_en_us = backofficePim_en_us;
